/** Serializes launch ownership across legacy and native executors. */
export class MacroLaunchFence {
  private readonly stoppers = new Set<() => Promise<boolean>>();
  private release: Promise<boolean> = Promise.resolve(true);

  public register(stop: () => Promise<boolean>): () => void {
    this.stoppers.add(stop);
    return () => { this.stoppers.delete(stop); };
  }

  public stop(): Promise<boolean> {
    // Invoke immediately to invalidate old callbacks before awaiting release.
    const pending = [...this.stoppers].map(stop => {
      try { return Promise.resolve(stop()).catch(() => false); }
      catch { return Promise.resolve(false); }
    });
    this.release = Promise.all([this.release, ...pending]).then(results => results.every(Boolean));
    return this.release;
  }

  public ready(): Promise<boolean> { return this.release; }
}
